import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AdminResponses from '@/pages/AdminResponses';
import CollectionsLanding from '@/pages/CollectionsLanding';

export default function App() {
  const localAdminEnabled = import.meta.env.DEV || import.meta.env.VITE_LOCAL_ADMIN_ENABLED === 'true';

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/admin"
          element={localAdminEnabled ? <AdminResponses /> : <Navigate to="/" replace />}
        />
        <Route path="/" element={<CollectionsLanding />} />
        {/* Legacy path from the old www.clipiti.com/collections URL. */}
        <Route path="/collections/admin" element={<Navigate to="/admin" replace />} />
        <Route path="/collections" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
